import { postRunAppAction } from '@/redux/actions/gravityActions';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import argumentSelectors from '@/redux/selectors/argumentSelectors';
import { query } from '@/redux/selectors/querySelectors';
import { useSelector } from 'react-redux';

const noSelection = () => undefined;

const useRunStepAction = (dataSource) => {
  const app = useSelector(argumentSelectors[dataSource].activeApp);
  const stepId = useArgSelector(query, 'stepId');
  const credentialId = useSelector(argumentSelectors[dataSource].activeCredentialId);
  // Embedded steps carry no credentialId; the server resolves their connection from these two.
  const integrationAppId = useSelector(argumentSelectors[dataSource].activeIntegrationAppId || noSelection);
  const installationId = useSelector(argumentSelectors[dataSource].activeInstallationId || noSelection);
  const pathname = useSelector((state) => state?.router?.location?.pathname);
  const isAppScreen = pathname?.includes('/apps');

  return async (actionSlug, { arguments: args, options, callback, onResponse }) => {
    const action = app?.actions.find((n) => n.slug === actionSlug);
    return postRunAppAction(
      {
        appId: app?.id,
        appVersion: app?.version,
        stepId,
        credentialId,
        integrationAppId,
        installationId,
        arguments: args,
        options,
        lookup: true,
        cache: false,
        actionId: action?.id,
        transform: true,
        useAdminCredentials: isAppScreen
      },
      callback,
      onResponse
    );
  };
};

export default useRunStepAction;
